import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { theme } from 'utils/theme/theme';
import { ThemeProviderProps } from './ThemeProvider.types';

export const ThemeProvider = ({ children }: ThemeProviderProps): JSX.Element => (
    <SCThemeProvider theme={theme}>{children}</SCThemeProvider>
);
